const NBSP = String.fromCharCode(160)

const groupThousands = (integer: string): string => integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

const formatDecimal = (value: number, digits: number): string => {
    const [integer, decimal = ''] = Math.abs(value).toFixed(digits).split('.')
    const trimmed = decimal.replace(/0+$/, '')

    return trimmed ? `${groupThousands(integer)},${trimmed}` : groupThousands(integer)
}

export const formatNumber = (value: number): string => groupThousands(Math.round(Math.abs(value)).toString())

export const formatCurrency = (value: number, options: { cents?: boolean } = {}): string => {
    const cents = options.cents ?? false
    const [integer, decimal] = Math.abs(value).toFixed(cents ? 2 : 0).split('.')
    const sign = value < 0 ? '-' : ''

    return `${sign}R$${NBSP}${groupThousands(integer)}${decimal ? `,${decimal}` : ''}`
}

export const formatCompactCurrency = (value: number): string => {
    const absolute = Math.abs(value)
    const sign = value < 0 ? '-' : ''

    if (absolute >= 1000000) return `${sign}R$${NBSP}${formatDecimal(absolute / 1000000, absolute >= 10000000 ? 0 : 1)}${NBSP}mi`
    if (absolute >= 1000) return `${sign}R$${NBSP}${formatDecimal(absolute / 1000, absolute >= 100000 ? 0 : 1)}${NBSP}mil`

    return formatCurrency(value)
}

export const formatPercent = (rate: number, digits = 2): string => `${formatDecimal(rate * 100, digits)}%`

export const onlyDigits = (value: string): string => value.replace(/\D/g, '')

export const maskPhone = (value: string): string => {
    const digits = onlyDigits(value).slice(0, 11)

    if (digits.length === 0) return ''
    if (digits.length <= 2) return `(${digits}`

    const area = digits.slice(0, 2)
    const rest = digits.slice(2)

    if (rest.length <= 4) return `(${area}) ${rest}`
    if (digits.length <= 10) return `(${area}) ${rest.slice(0, 4)}-${rest.slice(4)}`

    return `(${area}) ${rest.slice(0, 5)}-${rest.slice(5)}`
}

export const maskCurrencyInput = (value: string): string => {
    const digits = onlyDigits(value).replace(/^0+/, '').slice(0, 9)

    return digits ? groupThousands(digits) : ''
}
